import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { updateOrgUsers, updateOrgUserReset } from '../../../profile/actions/admin-user-actions'

import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';

import { Box, Flex, useToast } from '@chakra-ui/react';
import { BsCheckCircle, BsCircle } from 'react-icons/bs';
import UserProfileImageDisplay from '../../../global/components/helper-components/components/UserProfileImageDisplay';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';


function EditTeamMemberModule({
  orgUser,
  role,
  orgIdToken,
  isLastAdmin,
  handleCloseModal,
  // Redux
  manageAdminOrgUsersOutcome,
  isMobileView,
  // Actions
  updateOrgUsers,
  updateOrgUserReset
}) {

  const { userId, memberFirstName, memberLastName, memberName, userOrgTitle, memberProfilePicSrc } = orgUser || {};
  const applyLastAdminRestriction = (isLastAdmin === true && role === 'admin-user') ? true : false;

  const toast = useToast();
  const [showNoRoleError, setShowNoRoleError] = useState(false);
  const [removingInProgress, setRemovingInProgress] = useState(false);
  const [editingInProgress, setEditingInProgress] = useState(false);

  const [showRemoveMemberModal, setShowRemoveMemberModal] = useState(false)

  const [chosenRole, setChosenRole] = useState(role)
  const [userOrgTitleDisplay, setUserOrgTitle] = useState(userOrgTitle)
  const [memberFirstNameDisplay, setUserFirstName] = useState(memberFirstName)
  const [memberLastNameDisplay, setUserLastName] = useState(memberLastName)

  // Input validation Errors
  const [showMissingTitleError, setShowMissingTitleError] = useState(false)
  const [showMissingFirstNameError, setShowMissingFirstNameError] = useState(false)
  const [showMissingLastNameError, setShowMissingLastNameError] = useState(false)


  // UX & State Management
  useEffect(() => {
    if (manageAdminOrgUsersOutcome) {
      const { updatedSuccessfully, errorMessage } = manageAdminOrgUsersOutcome.data || {};

      const closeModalAndReset = () => {
        setEditingInProgress(false)
        setRemovingInProgress(false)
        handleCloseModal()
        updateOrgUserReset()
      }

      if (manageAdminOrgUsersOutcome.data === undefined && manageAdminOrgUsersOutcome.hasErrors) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            bannerText: "Error",
            label: manageAdminOrgUsersOutcome.errorMessage,
            isMobileView
          })
        )

        closeModalAndReset()
      }

      if (updatedSuccessfully === true) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            // bannerText: "",
            label: "Team member successfully updated",
            isMobileView
          })
        )

        closeModalAndReset()
      }
      else if (updatedSuccessfully === false && errorMessage) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            bannerText: "Error",
            label: errorMessage,
            isMobileView
          })
        )

        closeModalAndReset()
      }
    }

  }, [manageAdminOrgUsersOutcome, handleCloseModal, toast]);



  // Component functionality
  const handleChange = (event) => {
    const value = event.target.value;
    const variableName = event.target.name;
    switch (variableName) {
      case ('userOrgTitle'): {
        setUserOrgTitle(value)
        break;
      }
      case ('memberFirstName'): {
        setUserFirstName(value)
        break;
      }
      case ('memberLastName'): {
        setUserLastName(value)
        break;
      }
      default: {
        console.log('There is no variable with this name', variableName)
        break;
      }
    }
  }

  const handleChooseRole = (role) => {
    // Scenario: When user wants to remove his choice 
    if (chosenRole === role) {
      setChosenRole('')
      setShowNoRoleError(false)
    } else {
      // Scenario: When user picks a role for the first time
      // Scenario: Also when user switches from one role to the other role
      setChosenRole(role)
      setShowNoRoleError(false)
    }
  }

  const handleEditTeamMember = () => {

    const roleChanged = (role === chosenRole) ? false : true;

    if (!userOrgTitleDisplay) {
      setShowMissingTitleError(true)
    }

    if (!memberFirstNameDisplay) {
      setShowMissingFirstNameError(true)
    }

    if (!memberLastNameDisplay) {
      setShowMissingLastNameError(true)
    }

    if (userOrgTitleDisplay && memberFirstNameDisplay && memberLastNameDisplay) {

      let newOrgUserProperties = {
        userId,
        updateEvent: 'update-org-user',
        currentRole: role,
        ...(memberFirstNameDisplay !== memberFirstName) && { firstName: memberFirstNameDisplay.trim() },
        ...(memberLastNameDisplay !== memberLastName) && { lastName: memberLastNameDisplay.trim() },
        ...(userOrgTitleDisplay !== userOrgTitle) && { userOrgTitle: userOrgTitleDisplay.trim() },
        ...(roleChanged === true) && { newOrgRole: chosenRole }
      }

      updateOrgUsers(newOrgUserProperties, orgIdToken)
      setEditingInProgress(true)
    }
  }

  const showRemoveConfirmModal = () => {
    setShowRemoveMemberModal(true)
  }

  const handleRemoveMember = () => {
    // This function is changes the status of a member from 'active' or 'pending', to 'deactivated'
    setRemovingInProgress(true)

    let newOrgUserProperties = {
      userId,
      updateEvent: 'deactivate-org-user'
    }

    updateOrgUsers(newOrgUserProperties, orgIdToken)
  }



  if (!showRemoveMemberModal) {
    return (
      <Box mt='1em' alignSelf='center'>
        <Box px='2em' mb='2em'>
          {/* <Box mt='0.5em' fontWeight='500' color='gray.700' mb='1em' letterSpacing='1px'>
            About
          </Box> */}

<Box mt='1em' mb='2em'>
          <UserProfileImageDisplay name={memberName} size='5em' profilePicture={memberProfilePicSrc} />
</Box>
          <Flex direction='column' gap='1.2em' mt='1em'>
            <Flex direction={['column', 'row']} gap='1.2em'>
              <LaunchdeckFormInput
                label='First name'
                name={'memberFirstName'}
                onChange={handleChange}
                value={memberFirstNameDisplay}
                // placeholder="Enter page name"
                isRequired={true}

                errorLogic={showMissingFirstNameError}
                errorMessage={'Please provide a first name for this user'}
              />

              <LaunchdeckFormInput
                label='Last name'
                name={'memberLastName'}
                onChange={handleChange}
                value={memberLastNameDisplay}
                isRequired={true}
                errorLogic={showMissingLastNameError}
                errorMessage={'Please provide a last name for this user'}
              />
            </Flex>

            <LaunchdeckFormInput
              label='Title'
              name={'userOrgTitle'}
              onChange={handleChange}
              value={userOrgTitleDisplay}
              isRequired={true}
              placeholder='e.g. Head of Growth, Cofounder'
              errorLogic={showMissingTitleError}
              errorMessage={'Please provide an official title for this user'}
            />

          </Flex>



          <Box>
            {(applyLastAdminRestriction === true) ?
              <Box rounded='0.25em' bg='pink.50' mt='1.5em' p='1em' fontSize='0.8em'>
                You are the sole Administrator to help manage team users and their settings
              </Box>
              :
              <>
                <Box mt='2em' fontWeight='500' color='gray.700'>
                  Role
                </Box>

                <Flex direction={['column', 'row', 'row', 'row']} justify='space-evenly' align='stretch' mt='1em' gap='2em'>
                  <Box flex='1' border='1px solid' borderColor={(chosenRole === 'admin-user') ? 'brand.300' : 'gray.300'} bg={(chosenRole === 'admin-user') && 'gray.50'} rounded='0.25em' py='0.75em' px='1.25em' cursor='pointer' onClick={() => handleChooseRole('admin-user')}>
                    <Flex justify='flex-start' align='center' mb='0.5em'>
                      <Box className='flip-in-hor-bottom'>
                        {
                          (chosenRole === 'admin-user') ? <Box as={BsCheckCircle} className='flip-in-hor-bottom' color='brand.500' width='2em' height='1.4em' mr='0.5em' /> :
                            <Box as={BsCircle} className='flip-in-hor-bottom' color='gray.300' width='2em' height='1.4em' mr='0.5em' />
                        }
                      </Box>
                      <Box color={(chosenRole === 'admin-user') ? 'brandDark.500' : 'gray.500'} lineHeight='1.375em'>Organization Administrator</Box>

                    </Flex>

                    <Box mt='0.5em' fontSize='0.75em' color={(chosenRole === 'admin-user') ? 'brandDark.500' : 'gray.500'} fontWeight='400' py='0.5em'> Manage organization users, billing, and set organization settings for all its users</Box>
                  </Box>


                  <Box flex='1' mt={['1em', '0', '0', '0']} border='1px solid' borderColor={(chosenRole === 'basic-user') ? 'brandPink.300' : 'gray.300'} bg={(chosenRole === 'basic-user') && 'gray.50'} rounded='0.25em' py='0.75em' px='1.25em' cursor='pointer' onClick={() => handleChooseRole('basic-user')}>
                    <Flex justify='flex-start' align='center'>
                      <Box className='flip-in-hor-bottom'>
                        {
                          (chosenRole === 'basic-user') ? <Box as={BsCheckCircle} className='flip-in-hor-bottom' color='brandPink.500' width='2em' height='1.4em' mr='0.5em' /> :
                            <Box as={BsCircle} className='flip-in-hor-bottom' color='gray.300' width='2em' height='1.4em' mr='0.5em' />
                        }
                      </Box>

                      <Box color={(chosenRole === 'basic-user') ? 'brandDark.500' : 'gray.500'} lineHeight='1.375em'>Organization User</Box>
                    </Flex>

                    <Box mt='0.5em' fontSize='0.75em' color={(chosenRole === 'basic-user') ? 'brandDark.500' : 'gray.500'} fontWeight='400' py='0.5em'> Access features & settings set by their Administrators</Box>
                  </Box>
                </Flex>
              </>

            }

            <Box mt='0.5em'>
              <WarningTextMessage errorLogic={showNoRoleError} message='Please indicate a role for this user' />
            </Box>



          </Box>
          <Flex justify='space-between' align='flex-end' mt='3em'>
            <Box color='gray.500' cursor='pointer' fontSize='0.75em' fontWeight='400' visibility={((applyLastAdminRestriction === false) && !editingInProgress) ? 'visible' : 'hidden'} onClick={applyLastAdminRestriction ? null : () => showRemoveConfirmModal()}>Deactivate user</Box>
            <LaunchdeckButton bg='brand.500' color='white' loadingLogic={editingInProgress} onClick={() => handleEditTeamMember()} label={'Save changes'} />
          </Flex>
        </Box>

      </Box>
    )
  }

  if (showRemoveMemberModal) {
    return (
      <Box w='100%' pb='2em' px='2em'>
        <Box  my='1.5em' fontWeight='400' color='gray.700' fontSize='0.875em'>
          <Box lineHeight='1.375em'>
            Once deactivated, {memberName}'s account and its content will be removed from your team.
          </Box>

          <Box lineHeight='1.375em' mt='1em'>
            Proceed?
          </Box>
        </Box>

         <Flex justify='flex-end' mt='3em' w='100%' >
            <LaunchdeckButton bg='brandPink.500' color='white' loadingLogic={removingInProgress} onClick={() => handleRemoveMember()} label={'Deactivate member'} />
          </Flex>
      </Box>
    )
  }
}


function mapStateToProps(state) {
  return {
    manageAdminOrgUsersOutcome: state.manageAdminOrgUsersOutcome.results,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateOrgUsers,
      updateOrgUserReset
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditTeamMemberModule));